import { render, staticRenderFns } from "./DistrictMessages.vue?vue&type=template&id=d489ffda"
import script from "./DistrictMessages.vue?vue&type=script&lang=js"
export * from "./DistrictMessages.vue?vue&type=script&lang=js"
import style0 from "./DistrictMessages.vue?vue&type=style&index=0&id=d489ffda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports